<template>
  <div class="guide-list">

      <guide-list-skeleton v-if="loading" style="margin-bottom: 100vh"></guide-list-skeleton>

      <div class="search">
          <van-search v-model="value" @click="$router.push({name:'search'})" placeholder="搜一搜">
              <template slot="left">
                  <span @click="cityPicker = true">{{position}}</span> <img src="/static/bytx/activity_list_filter_icon.svg" /> &nbsp;&nbsp;
              </template>
          </van-search>
      </div>

      <div class="tags">
          <van-tabs :swipeable="true" v-model="category_index" @click="changeCategory">
              <van-tab :title-class="'course-list-category-title'" v-for="(item,index) in categories" :key="index" :title="item.name" ></van-tab>
          </van-tabs>
          <div class="clear"></div>
      </div>

      <div v-if="list && list.length > 0" class="guide-list-section" >
          <van-row class="guide-list-section-box" @click="go_detail(item)" v-for="item in list" :key="item.id">
              <div class="guide-list-section-left">
                  <van-image
                      fit="cover"
                      class="guide-list-section-left-img"
                      :src="item.cover_img"
                      width="100%"
                      height="100%"
                  />
              </div>
              <div class="guide-list-section-right">
                  <div class="guide-list-section-right-title">{{item.title}}</div>
                  <div class="guide-list-section-right-detail">
                      <div>
                          {{item.created_at}}
                          <span style="margin-left: 8px">{{item.view_count}}人阅读</span>
                      </div>
                  </div>
              </div>
              <div class="clear"></div>
          </van-row>
      </div>

      <div class="van-list__finished-text" v-if="list.length > 6 && page === total_page">已到底部</div>
      <div v-else-if="list.length > 0 && total_page > page" class="finish-more" @click="fetch_more()">查看更多</div>
      <van-empty v-else-if="list.length===0" description="" image="/static/img/pic_blank_content.svg" >
          <template slot="description">
              <div style="text-align: center">博医同行持续更新中…</div>
              <div style="text-align: center;margin-top: 10px">先看看其他内容吧！</div>
              <div style="text-align: center;margin-top: 24px">
                  <van-button color="#0FB7AD" round size="small" style="width: 120px" @click="$toHomePage">
                      返回首页
                  </van-button>
              </div>
          </template>
      </van-empty>

      <van-popup v-model="cityPicker" position="bottom">
          <van-picker
              show-toolbar
              :columns="city"
              :value-key="'name'"
              @confirm="onCityConfirm"
              @cancel="cityPicker = false"
          />
      </van-popup>

  </div>
</template>
<script>
    import Interface from "@/util/interface"
    import articleListSkeleton from "@/skeleton/articleListSkeleton"
    export default {
        name: 'guide-list',
        components :{
            'guide-list-skeleton' : articleListSkeleton
        },
        data() {
            return {
                value: "",
                active: "",
                category_id :1,
                category_child_id:0,
                category_index:0,
                banners: [],
                categories: [
                    {id:1,name:"就诊指南"},
                    {id:2,name:"医保信息"},
                    {id:3,name:"就诊攻略"},
                    {id:4,name:""},
                ],
                categories_child:[],
                recommend:[],
                list:[],
                column:[],
                loading:true,
                page:1,
                pageSize:10,
                total_page:1,

                city:[],
                cityPicker:false,

                position:'全国'
            }
        },
        methods: {
            fetch(scene) {
                if (scene === 'guide') {
                    this.page = 1
                    let params = {
                        page:this.page,
                        pageSize:this.pageSize,
                        type : this.category_id,
                        address:this.position,
                    }
                    if(this.value != ""){
                        params.category_id = 0
                        params.title = this.value
                    }
                    Interface.getData('get', Interface.guide.list,params).then((res) => {
                        if(res.data.list != null){
                            this.list = res.data.list
                            this.total_page = res.data.total_page
                        }else{
                            this.list = [];
                            this.total_page = 1
                        }
                        setTimeout(()=>{this.loading = false;},500)
                    })
                } else if (scene === 'city') {
                    Interface.getData('get', Interface.user.city).then((res) => {
                        res.data.unshift({
                            id:0,
                            name:'全国',
                            children:null
                        })
                        this.city = res.data
                    })
                }
            },
            fetch_more(){
                this.page += 1
                let params = {
                    page : this.page,
                    pageSize:10,
                    category_id : this.category_id,
                }
                Interface.getData('get', Interface.guide.list,params).then((res) => {
                    this.list.push(...res.data.list)
                    this.total_page = res.data.total_page
                })
            },
            changeCategory(){
                this.category_id = this.categories[this.category_index].id
                try {
                    if(this.$route.params.category != this.category_index){
                        this.$router.push({path:"/guide-category/"+this.category_index})
                    }
                    Interface.getShareInfo(this,"就诊指南--博医同行","","就诊前必看攻略，看病更高效")
                }catch (err){

                }
                this.fetch('guide')
                sessionStorage.removeItem("guide_category_index")
            },
            onCityConfirm(values,index) {
                this.position = this.city[index].name
                this.cityPicker = false
                this.fetch('guide')
            },
            go_detail(item){
                sessionStorage.setItem("guide_category_index",this.category_index)
                this.$router.push({name:'guide-detail',params:{id:item.id}})
            }
        },
        created() {
            this.fetch('city')
            this.changeCategory()
            sessionStorage.removeItem("search_data")
        },
    }
</script>
<style lang="scss">
    @import "./index.scss";
</style>



// WEBPACK FOOTER //
// src/views/guide/list/index.vue